<div class="app">
  <main class="app__main">
    <router-outlet></router-outlet>
  </main>
  <app-toast-container />
</div>
